import * as React from "react";
import { Fragment } from "react";
import { Box, GridItem, Text } from "@chakra-ui/react";
import NumberField from "../../../../../../components/NumberField/NumberField";
import MissingDataGridItems from "./MissingDataGridItems";
import { MEASURES, POWER_SOURCES } from "../../../../../OrganizationQuestionnaire/helpers";

/** * 
 * @deprecated Merge and replace with TotalEmissionsGridItems to avoid code duplication.
 * This will also fix handling of biogenic items.
 * @param {*} param0 
 * @returns 
 */
function TotalEmissionsGridItems({ data, sectionItems, dataType }) {
	const section = [];

	sectionItems.forEach(sectionItem => {
		const dataObject = dataType === "electricity" ?
			data[dataType].items.find(source => source.electricityType === sectionItem) :
			data[dataType].items.find(source => source.consumptionType.code === sectionItem.code);

		if ( ! dataObject) {
			return;
		}
		let subTitle = "";
		if (dataObject.itemsPerMeasures.length === 1) {
			// The consumption for the current item has only one measuring unit,
			// so we are showing the unit (as subTitle) next to the item name, and we do not add any sub items
			const measureName = MEASURES[dataObject.itemsPerMeasures[0].measure.code] ?? dataObject.itemsPerMeasures[0].measure.name;
			subTitle = ` (${measureName})`;
		}

		const consumptionItemName = dataType === "electricity" ?
			POWER_SOURCES[sectionItem] ?? sectionItem :
			POWER_SOURCES[sectionItem?.code] ?? sectionItem?.name ?? sectionItem?.code;

		// Adding group header row
		section.push(<Fragment key={`group-header-${sectionItem.code ?? sectionItem}`}>
			<GridItem>
				<Box
					display="flex"
					alignItems="center"
					fontSize="sm"
					whiteSpace="break-spaces">
					<Text>
						<b>{consumptionItemName}</b>{subTitle ? subTitle : ""}
					</Text>
				</Box>
			</GridItem>
			<GridItem display="flex" justifyContent="end" textAlign="right" alignItems="center">
				{dataObject.itemsPerMeasures.length === 1 ?
					<NumberField value={dataObject.itemsPerMeasures[0].consumption} /> : "-"
				}
			</GridItem>
			<GridItem display="flex" justifyContent="end" alignItems="center">
				<NumberField value={dataObject.co2Emissions} fontWeight="bold" />
			</GridItem>
		</Fragment>);

		if (dataObject.itemsPerMeasures.length > 1) {
			// Adding sub items for all consumptions > 0, each on separate row
			section.push(dataObject.itemsPerMeasures.map(measureItem => {
				return <Fragment key={`${dataType}-${sectionItem.code ?? sectionItem}-${measureItem.measure.id}`}>
					<GridItem>
						<Box inlineSize="300px">
							<Text
								display="flex"
								justifyContent="start"
								alignItems="center"
								fontSize="sm"
								whiteSpace="break-spaces"
								marginLeft={6}
							>
								{MEASURES[measureItem.measure.code] ?? measureItem.measure.name}
							</Text>
						</Box>
					</GridItem>
					<GridItem>
						<NumberField value={measureItem.consumption} />
					</GridItem>
					<GridItem>
						<NumberField value={measureItem.co2Emissions} />
					</GridItem>
				</Fragment>;
			}));
		}
	});

	if (section.length === 0) {
		section.push(<MissingDataGridItems key={`${dataType}-missing`} value={0} />);
	}

	return section;
}

export default TotalEmissionsGridItems;